import axios from "axios";
import config from "../../config/constants";
import {
  loadProcessToken,
  showErrorToaster
} from "./index";
import { toastr } from 'react-redux-toastr';

import healthData from "../../data/asset_health_page/asset_health_history_data";

export const GET_HEALTH_REPORT_DATA = 'GET_HEALTH_REPORT_DATA';

export const LOADING_FEATURE_IMAGE = 'FETCH_VISUAL_RUL_CHART';
export const SUCCESS_FEATURE_IMAGE = 'SUCCESS_FEATURE_IMAGE';
export const FEATURE_IMAGE = 'FEATURE_IMAGE';
export const FAILURE_FEATURE_IMAGE = 'FAILURE_FEATURE_IMAGE';

export const getHealthReportChart = (scope) => (dispatch, getState) => {
    dispatch({
        type: GET_HEALTH_REPORT_DATA,
        payload: healthData
    });
};

export const getVisualizationRULChart = (src ,scope) => (dispatch, getState) => {
    dispatch({ type: LOADING_FEATURE_IMAGE, payload: true,});

    convertImgToBase64URL(src, function(url){
        fetch(url)
            .then(res => {
                dispatch({
                    type: SUCCESS_FEATURE_IMAGE,
                    payload: res.url,
                });

            })
    },"image/png");
};



const convertImgToBase64URL = (url, callback, outputFormat) =>{
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = function(){
        let canvas = document.createElement('CANVAS'),
            ctx = canvas.getContext('2d'), dataURL;
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        dataURL = canvas.toDataURL(outputFormat);
        callback(dataURL);
        canvas = null;
    };
    img.src = url;
};

export const loadDemoFeatureImage = (src, dispatch) => {
    dispatch({ type: LOADING_FEATURE_IMAGE, payload: true,});
    convertImgToBase64URL(src, function(url){
        fetch(url)
            .then(res => {
                dispatch({
                    type: SUCCESS_FEATURE_IMAGE,
                    payload: res.url,
                });

            })
    },"image/png");
};


export const loadFeatureImage = (historyData, location, scope) => {
    const demo = false;
    if (demo){
        return (dispatch, getState) => {
            loadDemoFeatureImage(location, dispatch);
        }
    } else {
        return (dispatch, getState) => {
            loadFeatureImageAPI(historyData, location, dispatch);
        }
    }
}

export const loadFeatureImageAPI = (historyData, location, dispatch) => {
    let token = loadProcessToken();
    dispatch({ type: LOADING_FEATURE_IMAGE, payload: true,});
    console.log("Calling API");
    console.log(location);
    let url =config.PLATFORM_URL + `aiservice/build_feature_image?project=${historyData.ai_project_name}&storage_type=${historyData.storage_type}&file_path=${location}`;
    console.log(url);
    axios.get(url).then(({ data }) => {
        dispatch({
            type: FEATURE_IMAGE,
            dataLoaded:true,
            payload: data
        });
    }).catch(function (error) {
        if (error.response) {
           console.log("error response");
           console.log(error.response);
           toastr.error('Failed to load image:', error.response.data.Error);
           dispatch({
              type: FAILURE_FEATURE_IMAGE,
              dataLoaded:false,
              error: error.response.data.Error
          });
        } else {
          toastr.error('Failed to load image');
           dispatch({
              type: FAILURE_FEATURE_IMAGE,
              dataLoaded:false,
              error: 'Failed to load image'
          });
        }
    });
}
